import React from "react";
import { useState,useEffect,useContext } from "react";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import { Image } from "react-bootstrap";
import logo from "../assets/images/samagra-logo.png";
// import ecoclub from "../assets/images/ecoclub-logo.png";
import ecoclub from "../assets/images/Logo-2.png";
import MenuOpen from "../assets/images/bars.png";
import MOE from "../assets/images/schoolEdu-logo.png";
import { TbLogin2 } from "react-icons/tb";
import { House } from "phosphor-react";
import pmshreelogo from "../assets/images/pmshree-logo.png"
import AdminLoginModel from "./Authentication/AdminLoginModel";
import SchoolLoginModel from "./Authentication/SchoolLoginModel.jsx";
import FacultyLoginModel from "./Authentication/FacultyLoginModel.jsx";
import {jwtDecode} from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../context";
import { BsInfoCircle } from "react-icons/bs";
import { PiTarget } from "react-icons/pi";
import { MdOutlineLibraryBooks } from "react-icons/md";
import { TbSocial } from "react-icons/tb";
import {PiUsersThreeLight} from "react-icons/pi";
import { useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import { userLoggedOut } from "../redux/auth/authSlice";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";

function HeaderAdmin() {
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [authCategory, setAuthCategory] = useState(0);
  const location = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loginRole, setLoginRole] = useState(null);
  const handleClose = () => {setIsClick(false);setShow(false)};
  const handleClose2 = () => setShow2(false);
  // const [manu, setMenu] = useState(false);
  const { setSectionId } = useContext(AppContext);
  const userData = useSelector(state => state.auth.user);
  console.log('4333333333333333333333333333333333333',userData);
  const dispatch = useDispatch();
  

  const [isClick, setIsClick] = useState(false);
  const [role, setRole] = useState(null);
  const handleShow = () => setShow(true);
  // const handleShow2 = () => setShow2(true);
  const [manu, setMenu] = useState(false);
  const [showHeader,setShowHeader]=useState(false);
  const [showHeader2,setShowHeader2]=useState(false);
  const navigate = useNavigate();
  const menuHandle = () => {
    setMenu(!manu);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const [showLoginDropdown, setShowLoginDropdown] = useState(false); 
  const [userName, setUserName] = useState("");

  const handleSelectLogin = (selectedRole) => {
    setRole(selectedRole); // Set the role to show the respective login modal
    setIsClick(true);
    setShowLoginDropdown(false); // Close the dropdown when a login option is selected
  };

   const Logout = async () => {
        try {
          const makeLogout = await fetch(
            `https://ecoclubs.education.gov.in/api/logout`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
              },
              credentials: "include",
            }
          );
          if (makeLogout.ok) {
           //  toast.success("Logout Successfully");
          }
        } catch (error) {
          toast.error("Logout Failed");
          console.log(error);
        }
        dispatch(userLoggedOut());
      };

  const handleLogout = async() => {
    await Logout()
    setIsLoggedIn(false); // Update state
    navigate("/"); // Redirect to homepage
    ;
  };

  // useEffect(() => {
  //   const isLoginPage = location.pathname === "/admin/login";
  
  //   if (isLoginPage) {
  //     if (userData) {
  //       if (userData.role === 1) {
  //         navigate("/admin");
  //       } else if (userData.role === 4) {
  //         navigate("/admin/state-level");
  //       }
  //     }
  //     return;
  //   }
  
  //   if (!userData) {
  //     navigate("/");
  //     return;
  //   }
  
  //   if (userData) {
  //     setIsLoggedIn(true);
  //     setUserName(userData.username);
  //     setLoginRole(userData.role);
  
  //     if (userData.role === 1 && !location.pathname.startsWith("/admin")) {
  //       navigate("/admin");
  //     } else if (userData.role === 4 && !location.pathname.startsWith("/admin/state-level")) {
  //       navigate("/admin/state-level");
  //     }
  //   }
  // }, [userData, location.pathname, navigate]);
  
  useEffect(() => {
    const isLoginPage = location.pathname === "/admin/login";
  
    const stateLevelAllowedPaths = [
      "/admin/state-level",
      "/admin/view-state",
      "/admin/collaboration",
      "/Ekpedmaakenaam",
      "/view-schools",
      "/view-schools-notifications",
      "/admin/environment-day-dashboard",
      "/admin/state/themes-analysis",
      "/admin/swachhata-hi-seva",
      "/admin/swm-report",
      "/admin/e-waste-drive",
      "/admin/special-campaign-6-report",
      "/admin/brics-report"
    ];
  
    const adminAllowedPaths = [
      "/admin",
      "/admin/view",
      "/admin/level-2",
      "/admin/view-district",
      "/admin/admin-collaboration",
      "/admin/view-state",
      "/Ekpedmaakenaamadmin",
      "/Ekpedmaakenaamadmin/district-wise",
      "/view-schools",
      "/view-schools-notifications",
      "/ras-activity-admin",
      "/admin/environment-day-dashboard",
      "/admin/state/themes-analysis",
      "/admin/swachhata-hi-seva",
      "/admin/swm-report",
      "/admin/e-waste-drive",
      "/admin/special-campaign-6-report",
      "/admin/brics-report"
    ];
  
    const pathLower = location.pathname.toLowerCase();
    const isThemesAnalyticsPath = 
      pathLower === "/admin/themes-analytics" || 
      pathLower.startsWith("/admin/themes-analytics/theme/") ||
      pathLower.startsWith("/admin/state/themes-analytics/theme/") ||
      pathLower.startsWith("/admin/state/themes-analysis/theme/");

    const isAllowedPathForStateLevel = 
      stateLevelAllowedPaths.some(p => p.toLowerCase() === pathLower) || 
      isThemesAnalyticsPath;

    const isAllowedPathForAdmin = 
      adminAllowedPaths.some(p => p.toLowerCase() === pathLower) || 
      isThemesAnalyticsPath;

    console.log("HeaderAdmin route check:", {
      pathname: location.pathname,
      role: userData?.role,
      isThemesAnalyticsPath,
      isAllowedPathForStateLevel,
      isAllowedPathForAdmin
    });
  
    if (isLoginPage) {
      if (userData) {
        console.log("On login page with userData, redirecting...");
        const adminType = localStorage.getItem("adminType");
        if (userData.role === 1) {
          if (adminType === "rasadmin") {
            navigate("/ras-activity-admin");
          } else {
            navigate("/admin/environment-day-dashboard");
          }
        } else if (userData.role === 4) {
          navigate("/admin/environment-day-dashboard");
        }
      }
      return;
    }
  
    if (!userData) {
      console.log("No userData, redirecting to home.");
      navigate("/");
      return;
    }
  
    setIsLoggedIn(true);
    setUserName(userData.username);
    setLoginRole(userData.role);
  
    if (userData.role === 1) {
      console.log("User has role 1 (admin)");
      const adminType = localStorage.getItem("adminType");
      if (!isAllowedPathForAdmin) {
        console.log("Redirecting admin user to /admin");
        if (adminType === "rasadmin") {
          navigate("/ras-activity-admin");
        } else {
          navigate("/admin/environment-day-dashboard");
        }
      } else {
        console.log("Already on a valid admin route, no redirect needed.");
      }
    } else if (userData.role === 4) {
      console.log("User has role 4 (state-level)");
      if (!isAllowedPathForStateLevel) {
        console.log("Redirecting to /admin/environment-day-dashboard...");
        navigate("/admin/environment-day-dashboard");
      } else {
        console.log("Already on a valid state-level route, no redirect needed.");
      }
    }
  }, [userData, location.pathname, navigate]);
  
  

 

  const handleLogOut = () => {
    localStorage.clear();
    navigate("/")
    navigate(0)
  }
  const handleHome = () => {
    navigate("/")
    navigate(0)
  }

  const handleViewexit = () => {
    setIsClick(false);
  }

  const handleHomeButton = () => {
    // "Home" for a signed-in user is their own dashboard, from wherever they
    // are — it used to work only on "/" and dropped everyone else on the
    // public landing page instead.
    if (userData) {
      if (loginRole === 1) {
        // the RAS admin has a dashboard of its own
        navigate(localStorage.getItem("adminType") === "rasadmin"
          ? "/ras-activity-admin"
          : "/admin/environment-day-dashboard");
      } else if (loginRole === 2) {
        navigate("/school");
      } else if (loginRole === 4) {
        const stateMap = {
          'andhrapradesh': 'ANDHRA PRADESH',
          'arunachalpradesh': 'ARUNACHAL PRADESH',
          'assam': 'ASSAM',
          'bihar': 'BIHAR',
          'chhattisgarh': 'CHHATTISGARH',
          'goa': 'GOA',
          'gujarat': 'GUJARAT',
          'haryana': 'HARYANA',
          'himachalpradesh': 'HIMACHAL PRADESH',
          'jammu&kashmir': 'JAMMU & KASHMIR',
          'jharkhand': 'JHARKHAND',
          'karnataka': 'KARNATAKA',
          'kerala': 'KERALA',
          'madhyapradesh': 'MADHYA PRADESH',
          'maharashtra': 'MAHARASHTRA',
          'manipur': 'MANIPUR',
          'meghalaya': 'MEGHALAYA',
          'mizoram': 'MIZORAM',
          'nagaland': 'NAGALAND',
          'odisha': 'ODISHA',
          'punjab': 'PUNJAB',
          'rajasthan': 'RAJASTHAN',
          'sikkim': 'SIKKIM',
          'tamilnadu': 'TAMILNADU',
          'telangana': 'TELANGANA',
          'tripura': 'TRIPURA',
          'uttarakhand': 'UTTARAKHAND',
          'uttarpradesh': 'UTTAR PRADESH',
          'westbengal': 'West Bengal',
          'delhi': 'DELHI',
          'andaman&nicobarislands': 'ANDAMAN & NICOBAR ISLANDS',
          'chandigarh': 'CHANDIGARH',
          'damananddiu': 'DADRA & NAGAR HAVELI AND DAMAN & DIU',
          'lakshadweep': 'LAKSHADWEEP',
          'puducherry': 'Puducherry',
          'kvs': 'KENDRIYA VIDYALAYA SANGHATHAN',
          'nvs': 'NAVODAYA VIDYALAYA SAMITI',
          'ladakh': 'LADAKH',
        };
        const username = userData?.username || "";
        const stateKey = username.toUpperCase().startsWith('EC4ML_')
          ? username.split('_')[1].toLowerCase()
          : '';
        const stateValue = stateMap[stateKey] || null;
        navigate("/admin/environment-day-dashboard", { state: { stateValue } });
      } else {
        navigate("/faculty");
      }
    } else {
      navigate("/");
    }
  }; 
   const scrollToSection = (sectionId) => {
    console.log(`Navigating to section: ${sectionId}`); // Debug log
    setSectionId(sectionId); // Store the section ID in context
    navigate('/'); // Navigate to eco-club
    // Add a timeout to allow the page to load before scrolling
    setTimeout(() => {
        const section = document.getElementById(sectionId);
        if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
        }
    }, 100); // Adjust the timeout as necessary
};
  return (
    <div className="mainTopDiv">
       <header>
        <div className="row py-1 animate__animated animate__fadeInDown">
        <div className="logo-sec col-6 col-lg-9 text-start d-flex justify-content-between align-items-center">
            <div onClick={handleHome} title="" className="logo-eco">
              <Image src={ecoclub} alt="Logo" width="320px" />
            </div>
            
            <Link
              to="https://www.education.gov.in/"
              className="logo-moe"
              title=""
              target="_blank"
            >
              <Image src={MOE} alt="Logo" width={348} />
            </Link>
            <Link
              to="https://samagra.education.gov.in/"
              className="logo-dept"
              title=""
              target="_blank"
            >
              <Image src={logo} alt="Logo" width={240} />
            </Link>
            <Link
              to="https://pmshrischools.education.gov.in/"
              className="logo-moe"
              title=""
              target="_blank"
            >
              <Image src={pmshreelogo} alt="Logo" width={158} />
            </Link>
            
          </div>

          <div className={manu === true ? "menu-sec col-lg-3 col-md-3 openMenu" : "menu-sec col-md-3 col-lg-3"}>
            <div className="login-signup-sec">
              {!isLoggedIn ? (
                <>
                  {!window.location.href.includes("/admin/login") && (
                    <button title="Try for Free" className="btn-login-signup loginBtnnewhm" onClick={handleShow}>
                      Login
                      <ul className="hmLoginList">
                        <li>
                          <Link onClick={() => handleSelectLogin("school")}>School Login</Link>
                        </li>
                        <li>
                          <Link onClick={() => handleSelectLogin("faculty")}>Faculty Login</Link>
                        </li>
                      </ul>
                    </button>
                  )}
                  
                  
                </>
              ) : (
                <>
                 <button className="btn btn-primary mb-0" style={{ marginRight: '15px' }} onClick={() => handleHomeButton()}>Home</button>
                  <button className="btn btn-danger" onClick={handleLogout}>
                    Logout
                  </button>
                </>
              )}
            </div>
          </div>
        </div>    

        <Link
          className="menu-mobile-button"
          to={undefined}
          onClick={menuHandle}
        >
          <Image src={MenuOpen} alt="Menu" />
        </Link>
        <nav className={manu ? "navbars mobile open animate__animated animate__fadeInUp":"navbars animate__animated animate__fadeInUp"}>
          <ul className="d-flex justify-content-center pl-5">
            <li>
              <a href="#" onClick={() => scrollToSection('themes')}>
                <span><House size={30} /></span> Themes
              </a>
            </li>
            <li>
              <a href="#" onClick={() => scrollToSection('aboutEcoClubs')}>
              <BsInfoCircle size={22}/> About Eco Clubs for Mission LiFE
              </a>
            </li>
            <li>
              <a href="#" onClick={() => scrollToSection('objectivesGoals')}>
              <PiTarget size={24}/> Objectives & Goals
              </a>
            </li>
            <li>
              <a href="#" onClick={() => scrollToSection('publications')}>
              <MdOutlineLibraryBooks size={20}/> Publications
              </a>
            </li>
            <li>
              <a href="#" onClick={() => scrollToSection('getSocial')}>
              <PiUsersThreeLight size={20}/> Let's Get Social
              </a>
            </li>
            <li>
              <a href="#" onClick={() => scrollToSection('stakeholders')}>
              <TbSocial size={20}/> Stakeholders involved
              </a>
            </li>
          </ul>
        </nav>
        
      </header>
      {isClick && (
        <>
          {role === "school" && <SchoolLoginModel handleViewexit={handleClose} />}
          {role === "faculty" && <FacultyLoginModel handleViewexit={handleClose} />}
          {role === "admin" && <AdminLoginModel handleViewexit={handleClose} />}
        </>
      )}
    </div>
  );
}

export default HeaderAdmin;